export default __webpack_public_path__ + "static/media/chord.144c80d3.png";